export default __webpack_public_path__ + "static/media/a023-startup3-en.bf3b077c.png";